import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import "./is6.scss";

export default () => {
  const data = useStaticQuery(graphql`
    query is6 {
      file(relativePath: { eq: "components/pages/index/is6/certy.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <div className="is6">
      <div className="is6-container container">
        <div>
          <Img fluid={data.file.childImageSharp.fluid}></Img>
        </div>
        <div>
          <p>
          One of the Gujarat's leading OET preliminary provider institute recognized by OET Australia in Ahmedabad. Magdeline's Academy is also a One stop
            shop for providing OET Training to Nurses, Doctors, Dentists,
            Pharmacists.
          </p>
        </div>
      </div>
    </div>
  );
};
